"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _CountSelector_css = _interopRequireDefault(require("./CountSelector_css"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _messages = require("./messages");
var _getLanguage = _interopRequireDefault(require("../utils/getLanguage"));
var _useTextFromRef = _interopRequireDefault(require("../utils/useTextFromRef"));
const CountSelector = _ref => {
  let {
    currentCount = 1,
    label,
    onUpdate,
    min = 0,
    max = 20,
    incrementDeactivated = false,
    decrementDeactivated = false,
    className,
    themeColor = "primary"
  } = _ref;
  (0, _appendCss.default)("arc_count-selector", _CountSelector_css.default);
  const language = (0, _getLanguage.default)();
  const {
    ref,
    text
  } = (0, _useTextFromRef.default)();
  const msgs = _messages.messages[language];
  const onUpdateClick = direction => {
    let newVal;
    if (direction === "increment" && !incrementDeactivated && currentCount !== max) {
      newVal = currentCount + 1;
      onUpdate(newVal);
    } else if (direction === "decrement" && !decrementDeactivated && currentCount !== min) {
      newVal = currentCount - 1;
      onUpdate(newVal);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("CountSelector", className, "".concat(themeColor, "-color"))
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "CountSelector__label t-body-small",
    ref: ref
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: "CountSelector__selectors"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)("CountSelector__selectors-btn", {
      inactive: decrementDeactivated || currentCount === min
    }),
    onClick: () => onUpdateClick("decrement"),
    "aria-label": "".concat(msgs.decrement, " ").concat(text)
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "remove",
    type: "icon"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "CountSelector__selectors-number t-headline-small"
  }, currentCount), /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)("CountSelector__selectors-btn", {
      inactive: incrementDeactivated || currentCount === max
    }),
    onClick: () => onUpdateClick("increment"),
    "aria-label": "".concat(msgs.increment, " ").concat(text)
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "add",
    type: "icon"
  }))));
};
CountSelector.propTypes = {
  /** Current count of the selector */
  currentCount: _propTypes.default.number.isRequired,
  /** Label associated with the selector on the left */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired,
  /** Callback function that gets fired each increment/decrement event.  Returns updated count value. */
  onUpdate: _propTypes.default.func.isRequired,
  /** Minimum count before buttons are deactivated */
  min: _propTypes.default.number,
  /** Maximum count before buttons are deactivated */
  max: _propTypes.default.number,
  /** When true incrementing count will be deactivated */
  incrementDeactivated: _propTypes.default.bool,
  /** When true decrementing count will be deactivated */
  decrementDeactivated: _propTypes.default.bool,
  /** Additional className for custom styling */
  className: _propTypes.default.string,
  /** Theme color variant [primary, accent, error, success] */
  themeColor: _propTypes.default.oneOf(["primary", "accent", "error", "success"])
};
var _default = exports.default = CountSelector;